"use client"
import React, { useState } from 'react';

interface YouTubeLiteProps {
    videoId: string;
    title?: string;
}

const YouTubeLite = ({ videoId, title = 'YouTube video' }: YouTubeLiteProps) => {
    const [isIframeLoaded, setIsIframeLoaded] = useState(false);
    const thumbnail = `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
    const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;

    return (
        <div
            className="relative w-full pb-[56.25%] bg-cover bg-center cursor-pointer"
            style={{ backgroundImage: `url(${thumbnail})` }}
            onClick={() => setIsIframeLoaded(true)}
        >
            {!isIframeLoaded && (
                <div className="absolute inset-0 flex items-center justify-center">
                    <div className="text-white text-5xl bg-black/60 p-4 rounded-full">
                        ▶
                    </div>
                </div>
            )}
            {isIframeLoaded && (
                <iframe
                    src={embedUrl}
                    title={title}
                    className="absolute top-0 left-0 w-full h-full border-0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                />
            )}
        </div>
    );
};

export default YouTubeLite;
